import React from 'react'
import styled, { useTheme } from 'styled-components'

import { media, mediaMax } from 'styles/media'

import { FixedColumnsMasonry } from '../../../components/landing/MasonryImages'
import BaseContainer from '../../../components/layout/Container'
import { benefitsImages } from '../../aboutStories/Customer/content'

const MobileOnly = styled.div`
  ${media.md`
    display: none;
  `}
`

const DesktopOnly = styled.div`
  ${mediaMax.md`
    display: none;
  `}
`

const MasonryWrapper = styled.div`
  position: relative;
`

const MasonryInnerWrapper = styled(BaseContainer)`
  padding-top: 16px;

  ${media.md`
    padding-top: 30px;
    margin-bottom: 120px;
  `}
`

const Masonry = () => {
  const theme = useTheme()

  return (
    <MasonryWrapper>
      <MasonryInnerWrapper width={980}>
        <div
          style={{
            position: 'absolute',
            backgroundColor: theme?.['-ds-core-50']?.value,
            top: 0,
            right: 0,
            bottom: '50%',
            left: 0,
          }}
        />

        <DesktopOnly>
          <FixedColumnsMasonry
            columnsCount={3}
            images={benefitsImages}
            imagesPerColumn={{
              1: 3,
              2: 2,
              3: 2,
            }}
          />
        </DesktopOnly>

        <MobileOnly>
          <FixedColumnsMasonry
            columnsCount={2}
            gutter={16}
            images={benefitsImages}
            imagesPerColumn={{
              1: 3,
              2: 2,
              3: 2,
            }}
          />
        </MobileOnly>
      </MasonryInnerWrapper>
    </MasonryWrapper>
  )
}

export default Masonry
